// src/i18n/serveur.js
// Traduire ce que renvoie le SERVEUR : une erreur (`code` + `params`) ou un événement
// (`message_code` + `message_params`, ou `code` + `params` dans le temps réel).
//
// En FRANÇAIS, on affiche le texte du serveur tel quel (`message` / `event_message`) : c'est le
// texte d'origine, mot pour mot. Dans une autre langue, on traduit le code par le catalogue
// partagé (shared/i18n) ; sans code ou sans traduction, on retombe sur le texte français.
import { i18n } from './index';

const g = () => i18n.global;
const enFrancais = () => g().locale.value === 'fr';

// Erreur axios → texte à afficher. `defaut` = texte (déjà traduit) si le serveur n'a rien dit.
export function texteErreur(e, defaut = '') {
  const d = e && e.response && e.response.data;
  if (!d) return defaut;
  if (enFrancais() || !d.code) return d.message || defaut;
  const cle = `serveur.erreurs.${d.code}`;
  return g().te(cle) ? g().t(cle, d.params || {}) : (d.message || defaut);
}

// Paramètres d'un événement prêts pour l'affichage : les clés neutres (`nature`, `origine`,
// `raison`, `type`, `commande`) sont traduites par `serveur.valeurs`, `source` = nom donné sinon origine,
// et un paramètre absent (`nom`, `accessoire`) prend sa valeur par défaut (conventions
// de shared/i18n/fr.json).
function parametres(params) {
  const p = { ...(params || {}) };
  const valeur = (groupe, v) => {
    const cle = `serveur.valeurs.${groupe}.${v}`;
    return v != null && g().te(cle) ? g().t(cle) : v;
  };
  for (const groupe of ['nature', 'origine', 'raison', 'type', 'commande']) {
    if (p[groupe] != null) p[groupe] = valeur(groupe, p[groupe]);
  }
  if (p.source == null) p.source = p.nom || p.origine || '';
  for (const k of ['nom', 'accessoire']) {
    if (p[k] == null) {
      const cle = `serveur.valeurs.defaut.${k}`;
      if (g().te(cle)) p[k] = g().t(cle);
    }
  }
  if (Array.isArray(p.champs)) p.champs = p.champs.join(', ');
  return p;
}

// Réponse de SUCCÈS (`code` + `params`, depuis le 02/10/2026 pour les commandes) → texte à
// afficher. Même règle que les erreurs : en français, le texte du serveur ; ailleurs, le code
// traduit par le catalogue (`succes.<code>`), sinon `defaut`.
export function texteSucces(r, defaut = '') {
  if (!r) return defaut;
  if (enFrancais() || !r.code) return r.message || defaut;
  const cle = `serveur.succes.${r.code}`;
  return g().te(cle) ? g().t(cle, parametres(r.params)) : (r.message || defaut);
}

// Événement (historique ou temps réel) → texte à afficher.
export function texteEvenement(ev) {
  if (!ev) return '';
  const francais = ev.event_message != null ? ev.event_message : ev.message;
  const code = ev.message_code || ev.code;
  if (enFrancais() || !code) return francais || '';
  const cle = `serveur.evenements.${code}`;
  if (!g().te(cle)) return francais || '';
  return g().t(cle, parametres(ev.message_params || ev.params));
}
